// This file is auto-generated by a script. Do not modify this file manually. (Generated at 2026-01-30T17:49:47.768Z)
export enum FeatureFlagsEnum {
  /**
  * Habilita o login de usuários.
  */
  AuthUserLogin = "auth:user-login",
  /**
  * Habilita convites por senha para novos usuários.
  */
  AuthAllowPasswordInvites = "auth:allow-password-invites",
  /**
  * Habilita permissonamento de rotas gerais.
  */
  PermissionsGeneralRoutes = "permissions:general-routes",
  /**
  * Habilita permissonamento de rotas de pipes.
  */
  PermissionsPipesRoutes = "permissions:pipes-routes",
  /**
  * Habilita permissonamento de rotas de stages.
  */
  PermissionsStagesRoutes = "permissions:stages-routes",
  /**
  * Habilita permissonamento de rotas de cards.
  */
  PermissionsCardsRoutes = "permissions:cards-routes",
  /**
  * Habilita permissonamento de rotas de automation.
  */
  PermissionsAutomationRoutes = "permissions:automation-routes",
  /**
  * Habilita permissonamento de rotas de reports.
  */
  PermissionsReportsRoutes = "permissions:reports-routes",
  /**
  * Habilita permissonamento de rotas de roles.
  */
  PermissionsRolesRoutes = "permissions:roles-routes",
  /**
  * Habilita permissonamento de rotas de deadlines.
  */
  PermissionsDeadlinesRoutes = "permissions:deadlines-routes",
  /**
  * Habilita permissonamento de rotas de forms.
  */
  PermissionsFormsRoutes = "permissions:forms-routes",
  /**
  * Habilita permissonamento de rotas de labels.
  */
  PermissionsPipesLabelsRoutes = "permissions:pipes-labels-routes",
  /**
  * Habilita a alteração de permissões de um papel.
  */
  RolesChangePermissions = "roles:change-permissions",
  /**
  * Habilita o uso de presigned urls para o cloudfront.
  */
  InfraCloudfrontPresigned = "infra:cloudfront-presigned",
  /**
  * Habilita o uso de presigned urls para fazer upload pelo cloudfront.
  */
  InfraCloudfrontPresignedPost = "infra:cloudfront-presigned-post",
  /**
  * Habilita o uso do realtime.
  */
  InfraRealtime = "infra:realtime",
  /**
  * Habilita a configuração de mover cards automaticamente para o próximo pipe quando possivel.
  */
  PipeMoveCardWhenDone = "pipe:move-card-when-done",
  /**
  * Habilita o uso das automações v2.
  */
  AutomationsV2 = "automations:v2",
  /**
  * Habilita o uso de recursos do banco de dados.
  */
  FeatureDatabase = "feature:database",
  /**
  * Habilita o uso de recursos de times.
  */
  FeatureTeams = "feature:teams",
}